import * as api from '@/api/api';
import { TableRow } from '@/components/organisms/ApplyDataGrid/table/types';
import { GroupedCustomTabs } from '@/components/pages/offers-dashboard/types';
import { DefaultDashboardTabIds } from 'apply-data';
import { IApplyDashboardRowTotals, IApplyDashboardTabs, ITab } from 'api-paths-cas';

export const defaultTab = DefaultDashboardTabIds.LEADS;

export enum offersDashboardActionTypes {
  /**
   * Actions to fetch totals from apply-manager api.
   */
  CLEAR_TOTALS = '@@offers-dashboard/clear_totals',
  GET_TOTALS = '@@offers-dashboard/get_totals',
  GET_TOTALS_SUCCESS = '@@offers-dashboard/get_totals_success',
  GET_TOTALS_FAILURE = '@@offers-dashboard/get_totals_failure',

  /**
   * Actions to fetch offers from apply-manager api.
   */
  CLEAR_DASHBOARD_ROWS = '@@offers-dashboard/clear_offers',
  GET_DASHBOARD_ROWS = '@@offers-dashboard/get_dashboard_rows',
  GET_DASHBOARD_ROWS_SUCCESS = '@@offers-dashboard/get_dashboard_rows_success',
  GET_DASHBOARD_ROWS_FAILURE = '@@offers-dashboard/get_dashboard_rows_failure',

  /**
   * Actions to fetch filters (TODO: reimplement filters).
   */
  SET_FILTERS = '@@offers-dashboard/set_filters',
  GET_FILTERS = '@@offers-dashboard/get_filters',
  GET_FILTERS_SUCCESS = '@@offers-dashboard/get_filters_success',
  GET_FILTERS_FAILURE = '@@offers-dashboard/get_filters_failure',
  SET_FILTERS_VISIBLE = '@@offers-dashboard/set_filters_visible',

  SET_SORT = '@@offers-dashboard/set_sort',
  SET_IS_TASKBAR_OPEN = '@@offers-dashboard/set_taskbar_open',
  SET_IS_DROPDOWN_DISABLED = '@@offers-dashboard/set_is_dropdown_disabled',

  SELECT_ALL = '@@offers-dashboard/select_all',
  SET_SELECTED_ROWS = '@@offers-dashboard/set_selected_rows',

  SWITCH_TAB = '@@offers-dashboard/switch_tab',
  SET_CUSTOM_TABS = '@@offers-dashboard/set_custom_tabs',
}

export interface ITabTotals {
  [label: string]: number;
}

export interface ISelectedOption {
  [key: string]: number;
}

export interface IOffersDashboardFilterOptions {
  courses?: { label: string; value: string }[]; // course ID, course Name
  nationality?: { label: string; value: string }[]; // nationality ID, nationality Name
  applicationCountry?: { label: string; value: string }[]; // nationality ID, nationality Name
  residence?: { label: string; value: string }[]; // nationality ID, nationality Name
  tags?: { label: string; value: string; type: string }[];
  feeStatus?: string[];
  offerStatus?: string[];
}

export interface OffersDashboardState {
  readonly dashboardRows?: Array<TableRow>;
  readonly dashboardRowsLoaded: boolean;

  readonly stageTotals?: IApplyDashboardRowTotals;
  readonly allTotalsLoaded: boolean;

  readonly resetDropdownStatus: boolean;
  readonly isDropdownDisabled: boolean;
  readonly isTaskBarOpened: boolean;

  readonly dashboardTabs: IApplyDashboardTabs;
  readonly customTabs: GroupedCustomTabs;
  readonly tabs: ITab[];
  readonly tabsLoaded: boolean;
  readonly currentTab: string;

  readonly filters: Array<{ filterKey: string; value: string; label: string }>;
  readonly isFiltersVisible: boolean;
  filterOptionsLoaded: boolean;
  filterOptions: IOffersDashboardFilterOptions;

  readonly sort?: {
    col?: string;
    direction?: string;
  };

  readonly selectedRows: string[];
  readonly allSelected: boolean;
}

export interface IGetAllLeadsSearchParams extends Partial<api.IGetAllParams> {
  abortController: AbortController;
  idToken;
  startDate?: string;
  endDate?: string;
  stage: string | string[];
  intakeId?: string;
  uni?: string;

  page?: number;
  sortCol?: string;
  sortDir?: string;
  search?: string;

  filters?: { [filterKey: string]: string[] };

  agentId?: string | undefined;
  officeId?: string | undefined;
  currentUserRegionId?: string | undefined;

  tag?: string[];
  programmableTag: string[];

  tagsMatch?: string[];
  programmableTagsMatch?: string[];
}

export interface IGetAllDashboardRowsParams extends Partial<api.IGetAllParams> {
  abortController: AbortController;
  idToken;
  startDate?: string;
  endDate?: string;

  intakeId?: string;
  uni?: string;

  page?: number;
  pageSize?: number;
  sortCol?: string;
  sortDir?: string;
  search?: string;

  filters?: { [filterKey: string]: string[] };

  agentId?: string | undefined;
  officeId?: string | undefined;
  currentUserRegionId?: string | undefined;

  tag?: string[];
  programmableTag: string[];

  tagsMatch?: string[];
  programmableTagsMatch?: string[];

  appStages: string[];
  offerStages: string[];
}
